// Imports
import imgBaby from '../../assets/images/main/mistress-maria-professional-dominatrix-and-fem-dom-sexy-baby.webp';
import imgBabyBound from '../../assets/images/main/mistress-maria-professional-dominatrix-and-fem-dom-sexy-baby-bound.webp';
import imgBlackOutfit from '../../assets/images/main/mistress-maria-professional-dominatrix-and-fem-dom-sexy-black-outfit.webp';
import imgThrone from '../../assets/images/main/mistress-maria-professional-dominatrix-and-fem-dom-sexy-in-throne.webp';
import imgNurse from '../../assets/images/main/mistress-maria-professional-dominatrix-and-fem-dom-sexy-nurse.webp';
import imgSpanking from '../../assets/images/main/mistress-maria-professional-dominatrix-and-fem-dom-sexy-spanking.webp';
import imgSissyTraining from '../../assets/images/main/mistress-maria-professional-dominatrix-and-fem-dom-training-baby-sissy.webp';
// ====== New Imports ======
import domImage1 from '../../assets/images/domination/mistress-maria-norfolk-dominatrix-pro-domme-dungeon-picture-12xwg5.webp';
import domImage2 from '../../assets/images/domination/mistress-maria-norfolk-dominatrix-pro-domme-dungeon-picture-1tbmaf.webp';
import domImage3 from '../../assets/images/domination/mistress-maria-norfolk-dominatrix-pro-domme-dungeon-picture-4m4gkr.webp';
import domImage4 from '../../assets/images/domination/mistress-maria-norfolk-dominatrix-pro-domme-dungeon-picture-4ow7vh.webp';
import domImage5 from '../../assets/images/domination/mistress-maria-norfolk-dominatrix-pro-domme-dungeon-picture-6m2ccb.webp';
import domImage6 from '../../assets/images/domination/mistress-maria-norfolk-dominatrix-pro-domme-dungeon-picture-8btd6f.webp';
import domImage7 from '../../assets/images/domination/mistress-maria-norfolk-dominatrix-pro-domme-dungeon-picture-9o0b8d.webp';
import domImage8 from '../../assets/images/domination/mistress-maria-norfolk-dominatrix-pro-domme-dungeon-picture-9rrkz7.webp';
import domImage9 from '../../assets/images/domination/mistress-maria-norfolk-dominatrix-pro-domme-dungeon-picture-aedlo1.webp';
import domImage10 from '../../assets/images/domination/mistress-maria-norfolk-dominatrix-pro-domme-dungeon-picture-aihhuq.webp';
import domImage11 from '../../assets/images/domination/mistress-maria-norfolk-dominatrix-pro-domme-dungeon-picture-bgnfwu.webp';
import domImage12 from '../../assets/images/domination/mistress-maria-norfolk-dominatrix-pro-domme-dungeon-picture-cv07mc.webp';
import domImage13 from '../../assets/images/domination/mistress-maria-norfolk-dominatrix-pro-domme-dungeon-picture-d3odcl.webp';
import domImage14 from '../../assets/images/domination/mistress-maria-norfolk-dominatrix-pro-domme-dungeon-picture-dgovll.webp';
import domImage15 from '../../assets/images/domination/mistress-maria-norfolk-dominatrix-pro-domme-dungeon-picture-f6zm0n.webp';
import domImage16 from '../../assets/images/domination/mistress-maria-norfolk-dominatrix-pro-domme-dungeon-picture-fd6gjr.webp';
import domImage17 from '../../assets/images/domination/mistress-maria-norfolk-dominatrix-pro-domme-dungeon-picture-hra4ts.webp';
import domImage18 from '../../assets/images/domination/mistress-maria-norfolk-dominatrix-pro-domme-dungeon-picture-ogeq9w.webp';
import domImage19 from '../../assets/images/domination/mistress-maria-norfolk-dominatrix-pro-domme-dungeon-picture-p27qdk.webp';
import domImage20 from '../../assets/images/domination/mistress-maria-norfolk-dominatrix-pro-domme-dungeon-picture-tr17w6.webp';
import domImage21 from '../../assets/images/domination/mistress-maria-norfolk-dominatrix-pro-domme-dungeon-picture-vp9zqc.webp';
import domImage22 from '../../assets/images/domination/mistress-maria-norfolk-dominatrix-pro-domme-dungeon-picture-xbytd2.webp';
import domImage23 from '../../assets/images/domination/mistress-maria-norfolk-dominatrix-pro-domme-dungeon-picture-zumwsd.webp';
import domImage24 from '../../assets/images/domination/mistress-maria-norfolk-dominatrix-pro-domme-dungeon-picture-xbytas.webp';
import domImage25 from '../../assets/images/domination/mistress-maria-norfolk-dominatrix-pro-domme-dungeon-picture-xbyta1.webp';
import domImage26 from '../../assets/images/domination/mistress-maria-norfolk-dominatrix-pro-domme-dungeon-picture-xbyta0.webp';

import babyImage1 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-351kpe.webp';
import babyImage2 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-4w9dbq.webp';
import babyImage3 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-6bxb7i.webp';
import babyImage4 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-76bxub.webp';
import babyImage5 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-7b4ije.webp';
import babyImage6 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-8msx3w.webp';
import babyImage7 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-96wu02.webp';
import babyImage8 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-avxf9t.webp';
import babyImage9 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-b8ja8e.webp';
import babyImage10 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-d6tkhs.webp';
import babyImage11 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-fjlm6w.webp';
import babyImage12 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-fzhrtn.webp';
import babyImage13 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-hbeut4.webp';
import babyImage14 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-iyzo1j.webp';
import babyImage15 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-j6kec8.webp';
import babyImage16 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-ovqnie.webp';
import babyImage17 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-ppxp22.webp';
import babyImage18 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-qtng5e.webp';
import babyImage19 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-s947kn.webp';
import babyImage20 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-shnk7m.webp';
import babyImage21 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-u85uab.webp';
import babyImage22 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-uhifg0.webp';
import babyImage23 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-wmimdr.webp';
import babyImage24 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-wrzcin.webp';
import babyImage25 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-wydiwg.webp';
import babyImage26 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-xsbhwy.webp';
import babyImage27 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-z13ejq.webp';
import babyImage28 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-zg2cx5.webp';
import babyImage29 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-zg111.webp';
import babyImage30 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-zg112.webp';
import babyImage31 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-zg113.webp';
import babyImage32 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-zg114.webp';
import babyImage33 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-zg115.webp';
import babyImage34 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-zg116.webp';
import babyImage35 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-zg117.webp';
import babyImage36 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-zg118.webp';
import babyImage37 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-zg119.webp';
import babyImage38 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-zg120.webp';
import babyImage39 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-zg121.webp';
import babyImage40 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-zg122.webp';
import babyImage41 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-zg123.webp';
import babyImage42 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-zg124.webp';
import babyImage43 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-zg125.webp';
import babyImage44 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-zg126.webp';
import babyImage45 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-zg127.webp';
import babyImage46 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-zg128.webp';
import babyImage47 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-zg129.webp';
import babyImage48 from '../../assets/images/abdl/nanny-m-adult-baby-nappy-diaper-experience-zg130.webp';

// ====== New Gallery Array ======
export const dominationGalleryItemsArray = [
  {
    url: domImage1,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 1',
    ariaLabel: 'Domination image 1 of Mistress Maria',
  },
  {
    url: domImage2,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 2',
    ariaLabel: 'Domination image 2 of Mistress Maria',
  },
  {
    url: domImage3,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 3',
    ariaLabel: 'Domination image 3 of Mistress Maria',
  },
  {
    url: domImage4,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 4',
    ariaLabel: 'Domination image 4 of Mistress Maria',
  },
  {
    url: domImage5,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 5',
    ariaLabel: 'Domination image 5 of Mistress Maria',
  },
  {
    url: domImage6,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 6',
    ariaLabel: 'Domination image 6 of Mistress Maria',
  },
  {
    url: domImage8,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 8',
    ariaLabel: 'Domination image 8 of Mistress Maria',
  },
  {
    url: domImage9,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 9',
    ariaLabel: 'Domination image 9 of Mistress Maria',
  },
  {
    url: domImage10,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 10',
    ariaLabel: 'Domination image 10 of Mistress Maria',
  },
  {
    url: domImage11,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 11',
    ariaLabel: 'Domination image 11 of Mistress Maria',
  },
  {
    url: domImage12,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 12',
    ariaLabel: 'Domination image 12 of Mistress Maria',
  },
  {
    url: domImage13,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 13',
    ariaLabel: 'Domination image 13 of Mistress Maria',
  },
  {
    url: domImage26,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 13',
    ariaLabel: 'Domination image 13 of Mistress Maria',
  },
  {
    url: domImage14,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 14',
    ariaLabel: 'Domination image 14 of Mistress Maria',
  },
  {
    url: domImage15,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 15',
    ariaLabel: 'Domination image 15 of Mistress Maria',
  },
  {
    url: domImage25,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 15',
    ariaLabel: 'Domination image 15 of Mistress Maria',
  },
  {
    url: domImage16,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 16',
    ariaLabel: 'Domination image 16 of Mistress Maria',
  },
  {
    url: domImage17,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 17',
    ariaLabel: 'Domination image 17 of Mistress Maria',
  },
  {
    url: domImage18,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 18',
    ariaLabel: 'Domination image 18 of Mistress Maria',
  },
  {
    url: domImage24,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 18',
    ariaLabel: 'Domination image 18 of Mistress Maria',
  },
  {
    url: domImage19,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 19',
    ariaLabel: 'Domination image 19 of Mistress Maria',
  },
  {
    url: domImage20,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 20',
    ariaLabel: 'Domination image 20 of Mistress Maria',
  },
  {
    url: domImage21,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 21',
    ariaLabel: 'Domination image 21 of Mistress Maria',
  },
  {
    url: domImage22,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 22',
    ariaLabel: 'Domination image 22 of Mistress Maria',
  },
  {
    url: domImage23,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 23',
    ariaLabel: 'Domination image 23 of Mistress Maria',
  },
];

export const babyGalleryItemsArray = [
  {
    url: babyImage1,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 1',
    ariaLabel: 'ABDL image 1 of Nanny M',
  },
  {
    url: babyImage2,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 2',
    ariaLabel: 'ABDL image 2 of Nanny M',
  },
  {
    url: babyImage3,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 3',
    ariaLabel: 'ABDL image 3 of Nanny M',
  },
  {
    url: babyImage4,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 4',
    ariaLabel: 'ABDL image 4 of Nanny M',
  },
  {
    url: babyImage5,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 5',
    ariaLabel: 'ABDL image 5 of Nanny M',
  },
  {
    url: babyImage6,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 6',
    ariaLabel: 'ABDL image 6 of Nanny M',
  },
  {
    url: babyImage7,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 7',
    ariaLabel: 'ABDL image 7 of Nanny M',
  },
  {
    url: babyImage8,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 8',
    ariaLabel: 'ABDL image 8 of Nanny M',
  },
  {
    url: babyImage9,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 9',
    ariaLabel: 'ABDL image 9 of Nanny M',
  },
  {
    url: babyImage10,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 10',
    ariaLabel: 'ABDL image 10 of Nanny M',
  },
  {
    url: babyImage11,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 11',
    ariaLabel: 'ABDL image 11 of Nanny M',
  },
  {
    url: babyImage12,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 12',
    ariaLabel: 'ABDL image 12 of Nanny M',
  },
  {
    url: babyImage13,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 13',
    ariaLabel: 'ABDL image 13 of Nanny M',
  },
  {
    url: babyImage14,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 14',
    ariaLabel: 'ABDL image 14 of Nanny M',
  },
  {
    url: babyImage15,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 15',
    ariaLabel: 'ABDL image 15 of Nanny M',
  },
  {
    url: babyImage16,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 16',
    ariaLabel: 'ABDL image 16 of Nanny M',
  },
  {
    url: babyImage17,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 17',
    ariaLabel: 'ABDL image 17 of Nanny M',
  },
  {
    url: babyImage18,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 18',
    ariaLabel: 'ABDL image 18 of Nanny M',
  },
  {
    url: babyImage19,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 19',
    ariaLabel: 'ABDL image 19 of Nanny M',
  },
  {
    url: babyImage20,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 20',
    ariaLabel: 'ABDL image 20 of Nanny M',
  },
  {
    url: babyImage21,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 21',
    ariaLabel: 'ABDL image 21 of Nanny M',
  },
  {
    url: babyImage22,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 22',
    ariaLabel: 'ABDL image 22 of Nanny M',
  },
  {
    url: babyImage23,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 23',
    ariaLabel: 'ABDL image 23 of Nanny M',
  },
  {
    url: babyImage24,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 24',
    ariaLabel: 'ABDL image 24 of Nanny M',
  },
  {
    url: babyImage25,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 25',
    ariaLabel: 'ABDL image 25 of Nanny M',
  },
  {
    url: babyImage26,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 26',
    ariaLabel: 'ABDL image 26 of Nanny M',
  },
  {
    url: babyImage27,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 27',
    ariaLabel: 'ABDL image 27 of Nanny M',
  },
  {
    url: babyImage28,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 28',
    ariaLabel: 'ABDL image 28 of Nanny M',
  },
  {
    url: babyImage29,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 22',
    ariaLabel: 'ABDL image 22 of Nanny M',
  },
  {
    url: babyImage30,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 23',
    ariaLabel: 'ABDL image 23 of Nanny M',
  },
  {
    url: babyImage31,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 24',
    ariaLabel: 'ABDL image 24 of Nanny M',
  },
  {
    url: babyImage32,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 25',
    ariaLabel: 'ABDL image 25 of Nanny M',
  },
  {
    url: babyImage33,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 26',
    ariaLabel: 'ABDL image 26 of Nanny M',
  },
  {
    url: babyImage34,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 27',
    ariaLabel: 'ABDL image 27 of Nanny M',
  },
  {
    url: babyImage35,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 28',
    ariaLabel: 'ABDL image 28 of Nanny M',
  },
  {
    url: babyImage36,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 27',
    ariaLabel: 'ABDL image 27 of Nanny M',
  },
  {
    url: babyImage37,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 28',
    ariaLabel: 'ABDL image 28 of Nanny M',
  },
  {
    url: babyImage38,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 28',
    ariaLabel: 'ABDL image 28 of Nanny M',
  },
  {
    url: babyImage39,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 22',
    ariaLabel: 'ABDL image 22 of Nanny M',
  },
  {
    url: babyImage40,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 23',
    ariaLabel: 'ABDL image 23 of Nanny M',
  },
  {
    url: babyImage41,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 24',
    ariaLabel: 'ABDL image 24 of Nanny M',
  },
  {
    url: babyImage42,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 25',
    ariaLabel: 'ABDL image 25 of Nanny M',
  },
  {
    url: babyImage43,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 26',
    ariaLabel: 'ABDL image 26 of Nanny M',
  },
  {
    url: babyImage44,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 27',
    ariaLabel: 'ABDL image 27 of Nanny M',
  },
  {
    url: babyImage45,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 28',
    ariaLabel: 'ABDL image 28 of Nanny M',
  },
  {
    url: babyImage46,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 27',
    ariaLabel: 'ABDL image 27 of Nanny M',
  },
  {
    url: babyImage47,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 28',
    ariaLabel: 'ABDL image 28 of Nanny M',
  },
  {
    url: babyImage48,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 28',
    ariaLabel: 'ABDL image 28 of Nanny M',
  },
];

export const smallDomGalleryItemsArray = [
  {
    id: 1,
    src: domImage7,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 7',
    ariaLabel: 'Domination image 7 of Mistress Maria',
  },
  {
    id: 2,
    src: domImage14,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 14',
    ariaLabel: 'Domination image 14 of Mistress Maria',
  },
  {
    id: 3,
    src: domImage3,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 3',
    ariaLabel: 'Domination image 3 of Mistress Maria',
  },
  {
    id: 4,
    src: domImage19,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 19',
    ariaLabel: 'Domination image 19 of Mistress Maria',
  },
  {
    id: 5,
    src: domImage22,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 22',
    ariaLabel: 'Domination image 22 of Mistress Maria',
  },
  {
    id: 6,
    src: domImage9,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 9',
    ariaLabel: 'Domination image 9 of Mistress Maria',
  },
  {
    id: 7,
    src: domImage16,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 16',
    ariaLabel: 'Domination image 16 of Mistress Maria',
  },
  {
    id: 8,
    src: domImage5,
    title: 'Mistress Maria – Domination Gallery',
    alt: 'Domination image 5',
    ariaLabel: 'Domination image 5 of Mistress Maria',
  },
];

export const smallBabyGalleryItemsArray = [
  {
    id: 1,
    src: babyImage5,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 5',
    ariaLabel: 'ABDL image 5 of Nanny M',
  },
  {
    id: 2,
    src: babyImage12,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 12',
    ariaLabel: 'ABDL image 12 of Nanny M',
  },
  {
    id: 3,
    src: babyImage21,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 21',
    ariaLabel: 'ABDL image 21 of Nanny M',
  },
  {
    id: 4,
    src: babyImage17,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 17',
    ariaLabel: 'ABDL image 17 of Nanny M',
  },
  {
    id: 5,
    src: babyImage3,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 3',
    ariaLabel: 'ABDL image 3 of Nanny M',
  },
  {
    id: 6,
    src: babyImage14,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 14',
    ariaLabel: 'ABDL image 14 of Nanny M',
  },
  {
    id: 7,
    src: babyImage8,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 8',
    ariaLabel: 'ABDL image 8 of Nanny M',
  },
  {
    id: 8,
    src: babyImage25,
    title: 'Nanny M – ABDL Experience',
    alt: 'ABDL image 25',
    ariaLabel: 'ABDL image 25 of Nanny M',
  },
];


export const smallGalleryImagesArray = [
  {
    id: 1,
    src: imgBaby,
    name: 'Mistress Maria – Seductive Baby Doll',
    alt: 'Mistress Maria dressed as a seductive baby doll, showcasing control and allure',
    ariaLabel:
      'Image of Mistress Maria in a baby doll outfit demonstrating feminine dominance',
  },
  {
    id: 2,
    src: imgBabyBound,
    name: 'Mistress Maria – Bound Baby Doll',
    alt: 'Mistress Maria in a baby doll outfit with submissive bindings, emphasizing power play',
    ariaLabel:
      'Image of Mistress Maria with a bound baby doll look, highlighting submissive themes',
  },
  {
    id: 3,
    src: imgBlackOutfit,
    name: 'Mistress Maria – Commanding in Black',
    alt: 'Mistress Maria in a striking black domination outfit, exuding authority',
    ariaLabel:
      'Image of Mistress Maria dressed in black domination attire showing commanding presence',
  },
  {
    id: 4,
    src: imgThrone,
    name: 'Mistress Maria – On Her Throne',
    alt: 'Mistress Maria seated on her throne, radiating royal dominance and elegance',
    ariaLabel: 'Image of Mistress Maria sitting confidently on her throne',
  },
  {
    id: 5,
    src: imgNurse,
    name: 'Mistress Maria – The Dominant Nurse',
    alt: 'Mistress Maria dressed as a strict nurse with a provocative and powerful demeanor',
    ariaLabel:
      'Image of Mistress Maria in a dominant nurse outfit asserting control',
  },
  {
    id: 6,
    src: imgSpanking,
    name: 'Mistress Maria – Spanking Scene',
    alt: 'Mistress Maria delivering a firm spanking, exemplifying her control and authority',
    ariaLabel:
      'Image of Mistress Maria mid-spank, asserting dominance in a punishment scene',
  },
  {
    id: 7,
    src: imgSissyTraining,
    name: 'Mistress Maria – Sissy Training',
    alt: 'Mistress Maria guiding a submissive through sissy training, dressed to command and provoke',
    ariaLabel:
      'Image of Mistress Maria in a sissy training scenario demonstrating strict control',
  },
  {
    id: 8,
    src: imgBlackOutfit,
    name: 'Mistress Maria – Commanding in Black',
    alt: 'Mistress Maria in a striking black domination outfit, exuding authority',
    ariaLabel:
      'Image of Mistress Maria dressed in black domination attire showing commanding presence',
  },
];
